import { useMutation } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import {
  RedRed50,
  SequenceMenu,
  useModalState,
  useNotifications,
  SimpleModal
} from '@sequencehq/core-components'

export const ArchiveQuoteTemplateMenuItem = (props: {
  quoteTemplateId: string
  disabled?: boolean
  onSuccess?: () => void
}) => {
  const { isModalOpen, openModal, closeModal } = useModalState()
  const { archiveQuoteTemplate } = useArchiveQuoteTemplate({
    quoteTemplateId: props.quoteTemplateId,
    onSuccess: props.onSuccess
  })

  return (
    <>
      <SequenceMenu.Item
        uuid="archive-quote-template"
        label="Delete quote template"
        data-testid={`quoteTemplates.${props.quoteTemplateId}.menuItem.archive`}
        isDisabled={props.disabled}
        style={{ color: RedRed50 }}
        onClick={openModal}
      />
      <SimpleModal
        variant="dialog"
        data-testid="quoteTemplates.archiveQuoteTemplateDialog"
        isOpen={isModalOpen}
        onClose={closeModal}
        title="Delete quote template"
        submitButtonText="Delete"
        submittingButtonText="Deleting..."
        isDestructive
        disableSubmitOnEnter
        onSubmit={archiveQuoteTemplate}
      >
        This will delete the template immediately. This action cannot be undone.
      </SimpleModal>
    </>
  )
}

const useArchiveQuoteTemplate = (props: {
  quoteTemplateId: string
  onSuccess?: () => void
}) => {
  const { displayNotification } = useNotifications()
  const archiveQuoteTemplateMutation = useMutation(
    dashboard20240730Client.postArchiveQuoteTemplate
  )

  const archiveQuoteTemplate = async () => {
    const archivedTemplateResponse =
      await archiveQuoteTemplateMutation.mutateAsync({
        id: props.quoteTemplateId
      })

    if (!archivedTemplateResponse) {
      displayNotification('Failed to archive template', {
        type: 'error'
      })
      return false
    }

    displayNotification('Template archived', {
      type: 'success'
    })
    props.onSuccess?.()
    return true
  }

  return { archiveQuoteTemplate }
}
